import { Component } from "react";
import "./FormRow.scss";

export default class FormRow extends Component {
  render() {
    const { children } = this.props;
    let className = "form-row";

    return <div className={className}>{children}</div>;
  }
}
